import './app';
import $ from 'jquery';
import SeFacilityMap from'@golocalinteractive/se-facility-map';

// Intercept mobile toggle clicks in the capturing phase, before the SE plugin's
// jQuery handlers which can add 'noscroll' to body and break scrolling.
// Placed outside PAGE_TYPE check so it registers as early as possible.
(function () {
    var drawer = null;
    var overlay = null;

    function getOrCreateDrawer() {
        if (drawer) return drawer;

        // Create overlay
        overlay = document.createElement('div');
        overlay.className = 'mobile-filter-overlay';
        overlay.addEventListener('click', closeDrawer);

        // Create drawer
        drawer = document.createElement('div');
        drawer.className = 'mobile-filter-drawer';

        // Drag handle
        var handle = document.createElement('div');
        handle.className = 'mobile-filter-drawer-handle';
        handle.innerHTML = '<span></span>';
        drawer.appendChild(handle);

        // Create header with title and close button
        var header = document.createElement('div');
        header.className = 'mobile-filter-drawer-header';
        header.innerHTML = '<h5 class="filters-title m-0">Filter Locations</h5>' +
            '<button type="button" class="mobile-filter-drawer-close" aria-label="Close">' +
            '<span class="fas fa-times" aria-hidden="true"></span></button>';
        header.querySelector('.mobile-filter-drawer-close').addEventListener('click', closeDrawer);
        drawer.appendChild(header);

        // Move the actual .market-filters element into the drawer so checkbox
        // state is shared with the rest of the page (no cloning needed)
        var filters = document.querySelector('.market-filters');
        if (filters) {
            drawer.appendChild(filters);
        }

        // Footer with close action
        var footer = document.createElement('div');
        footer.className = 'mobile-filter-drawer-footer';
        footer.innerHTML = '<button type="button" class="mobile-filter-drawer-apply">Show Results</button>';
        footer.querySelector('.mobile-filter-drawer-apply').addEventListener('click', closeDrawer);
        drawer.appendChild(footer);

        document.body.appendChild(overlay);
        document.body.appendChild(drawer);
        return drawer;
    }

    function openDrawer() {
        var d = getOrCreateDrawer();
        overlay.style.display = 'block';
        document.body.classList.add('mobile-filters-open');
        // Trigger reflow so the transition animates from the initial state
        void overlay.offsetHeight;
        overlay.classList.add('visible');
        d.classList.add('open');
    }

    function closeDrawer() {
        if (!drawer) return;
        drawer.classList.remove('open');
        overlay.classList.remove('visible');
        document.body.classList.remove('mobile-filters-open');
        // Use a timeout matching the CSS transition duration to hide the overlay
        setTimeout(function () {
            if (!overlay.classList.contains('visible')) {
                overlay.style.display = 'none';
            }
        }, 350);
    }

    document.addEventListener('click', function (e) {
        // Mobile map toggle — scroll to map instead of fullscreen overlay
        var mapToggle = e.target.closest('.mobile-map-toggle');
        if (mapToggle) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
            document.body.classList.remove('noscroll');
            var mapEl = document.getElementById('marketMapAlt') || document.querySelector('.minimap-wrapper');
            if (mapEl) {
                mapEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            return;
        }

        // Mobile filter toggle — open slide-in drawer instead of toggling inline
        var filterToggle = e.target.closest('.mobile-filter-toggle');
        if (filterToggle) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
            openDrawer();
        }
    }, true);
})();

if (PAGE_TYPE === 'market') {
    let triggeredByLoadFromURL = false;

    function updateURL(selectedFeatureValues, selectedSizeValues) {
        // Construct a URLSearchParams object from the current URL's search parameters
        const params = new URLSearchParams(window.location.search);

        // Loop over the current URL parameters
        [...params.keys()].forEach((key) => {
            // If the parameter starts with 'feature' or 'size', delete it
            if (key.startsWith('feature') || key.startsWith('size')) {
                params.delete(key);
            }
        });

        // Only modify the URL parameters if the function wasn't triggered by loadFromURL
        if (!triggeredByLoadFromURL) {
            // Create a Set from the selected feature and size values to remove duplicates
            const uniqueFeatureValues = [...new Set(selectedFeatureValues)];
            const uniqueSizeValues = [...new Set(selectedSizeValues)];

            // Loop over the unique feature or size values
            uniqueFeatureValues.forEach((value) => {
                params.append('feature', value);
            });
            uniqueSizeValues.forEach((value) => {
                params.append('size', value);
            });
        }

        // Create a new URL object from the current window location
        const newurl = new URL(window.location);
        // Replace the search parameters of the new URL with our modified parameters
        newurl.search = params.toString();

        // Check if the new URL is different from the current one
        if (window.location.href !== newurl.href) {
            // If it's different, push the new URL to the browser history
            window.history.pushState({path: newurl.href}, '', newurl.href);
        }
    }

    function loadFromURL() {

        const urlParams = new URLSearchParams(window.location.search);
        // Prepare a map object of parameters
        const paramMap = {};

        // Loop over the URL parameters
        for (let [key, value] of urlParams.entries()) {
            // If the key starts with 'size' or 'feature', add it to the map
            if (key.startsWith('size') || key.startsWith('feature')) {
                paramMap[value] = true;
            }
        }

        // Loop over each checkbox
        $('.size-checkbox, .dynamic-feature-checkbox').each(function () {
            const checkbox = $(this);
            // The checkbox should be checked if its value exists in the map
            const shouldBeChecked = paramMap[checkbox.val().toLowerCase()] === true;

            // If the checkbox checked state should be different, change it and trigger the 'change' event
            if (checkbox.prop('checked') !== shouldBeChecked) {
                checkbox.prop('checked', shouldBeChecked);
                checkbox.trigger('change');
            }
        });
    }

    $(document).ready(function () {
        if (google !== undefined) {
            var colors = {
                primary: (typeof map_pin_color !== 'undefined') ? map_pin_color : $($('.btn-primary')[0]).css('background-color'),
                secondary: (typeof map_pin_color !== 'undefined') ? map_pin_color : $($('.btn-secondary')[0]).css('background-color'),
                primary_text: (typeof map_pin_label_color !== 'undefined') ? map_pin_label_color : $($('.btn-primary')[0]).css('color'),
            };

            const fullscreen = $('#marketMap').length > 0;
            try {
                var targetElement = '#marketMap';
                if ($('#marketMapAlt').length > 0) {
                    targetElement = '#marketMapAlt';
                }

                const securRenderer = {
                    render({ count, position }) {
                        const svg = window.btoa(`
                            <svg fill="${colors.primary}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
                                <circle cx="120" cy="120" opacity=".6" r="70" />
                                <circle cx="120" cy="120" opacity=".3" r="90" />
                                <circle cx="120" cy="120" opacity=".2" r="110" />
                                <circle cx="120" cy="120" opacity=".1" r="130" />
                            </svg>`);
                        return new google.maps.Marker({
                            icon: {
                                url: `data:image/svg+xml;base64,${svg}`,
                                scaledSize: new google.maps.Size(45, 45),
                            },
                            label: { text: String(count), color: colors.primary_text, fontSize: "12px" },
                            position,
                            // adjust zIndex to be above other markers
                            zIndex: 1000 + count,
                        });
                    }
                }

                var themap = new SeFacilityMap({
                    el: targetElement,
                    clustered: $('.marketMapClustered').length > 0,
                    clusterOptions: { renderer: securRenderer },
                    marker: {
                        labels: {
                            enable: true,
                            color: colors.primary_text
                        },
                        icon: {
                            path: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z",
                            strokeColor: colors.primary,
                            fillColor: colors.primary,
                            fillOpacity: 1.0,
                            scale: (32 / 512),
                            labelOrigin: new google.maps.Point(185, 180),
                            size: new google.maps.Size(32, 32),
                            anchor: new google.maps.Point(256, 512)
                        }
                    },
                    infoBubble: {
                        borderRadius: 10,
                        minHeight: 200,
                        arrowSize: 15,
                    },
                    map: {
                        minZoom: 3, // encompasses the contiguous US
                        gestureHandling: 'cooperative'
                    },
                    onCreated: function (map) {
                        if (fullscreen) {
                            function CenterControl(controlDiv, map) {
                                let controlUI = document.createElement('div');
                                controlUI.classList.add('map-control');
                                controlUI.title = 'Click to close the map';
                                controlDiv.appendChild(controlUI);

                                let controlText = document.createElement('div');
                                controlText.classList.add('map-control-text');
                                controlText.innerHTML = '<span class="fas fa-angle-left mr-2"></span> Back to Results';
                                controlUI.appendChild(controlText);
                                // Setup the click event listeners: hides the map off viewport
                                controlUI.addEventListener('click', function (e) {
                                    e.preventDefault();
                                    $('body').removeClass('noscroll');
                                    $("#marketMap").removeClass('tall').css('top', '100%');
                                    window.history.back();
                                });
                            }

                            let centerControlDiv = document.createElement('div');
                            let centerControl = new CenterControl(centerControlDiv, map);
                            centerControlDiv.index = 1;
                            map.controls[google.maps.ControlPosition.LEFT_TOP].push(centerControlDiv);
                        }
                    }
                });

                $(".btn-market-map, .mobile-map-toggle, .card-market-loc-pin").click(function (e) {
                    if (fullscreen) {
                        $('body').addClass('noscroll');
                        $("#marketMap").addClass('tall').animate({top: '0px'}, 300, themap.drawMap());
                    }
                    if (typeof $(this).data('index') !== 'undefined') themap.openMarker($(this).data('index') - 1);
                    else themap.closeMarker();
                });
            } catch (err) {
                console.log(err);
            }
        }

        $('input[name=distance], .feature-checkbox').change(function (e) {
            $(this).parents('form').submit();
        });

        $('.market-table .card').each(function (i) {
            var index = i + 1;

            $(this).find('.card-market-loc-pin').attr('data-index', index);
            $(this).find('.fa-map-marker').attr('data-content', index);
        });

        // toggle the filters on mobile
        $('.mobile-filter-toggle').on('click', function () {
            $('.market-filters').toggle();
            $('.market-micro-search').hide();
        });

        // toggle the search on mobile
        $('.mobile-search-toggle').on('click', function () {
            $('.market-micro-search').toggle();
            $('.market-filters').hide();
        });

        // This event handler function is triggered when any checkbox with class 'size-checkbox' or 'feature-checkbox' changes state (checked/unchecked)
        $('.size-checkbox, .dynamic-feature-checkbox').on('change', function () {
            let facilities = $('.facility-item');
            let featureCheckboxes = $('.dynamic-feature-checkbox:checked');
            let sizeCheckboxes = $('.size-checkbox:checked');
            let selectedFeatureValues = [];
            let selectedSizeValues = [];
            let filteredCount = $('.facility-item').length;

            // Add the value of each checked feature and size checkbox to the array
            featureCheckboxes.each(function () {
                selectedFeatureValues.push($(this).val().toLowerCase());
            });
            sizeCheckboxes.each(function () {
                selectedSizeValues.push($(this).val().toLowerCase());
            });

            // For each facility, check if it matches the selected features and sizes
            facilities.each(function () {
                // Get the feature and size data of the facility and convert it to lower case
                let facilityFeatureData = $(this).data('features').split(', ').map(i => i.toLowerCase());
                let facilitySizeData = $(this).data('sizes').split(', ').map(i => i.toLowerCase());

                // Check if every selected feature is included in the facility's features (or if no features are selected) same with sizes
                let isFeatureMatch = selectedFeatureValues.length == 0 || selectedFeatureValues.every(val => facilityFeatureData.includes(val));
                let isSizeMatch = selectedSizeValues.length == 0 || selectedSizeValues.every(val => facilitySizeData.includes(val));
                // If both features and sizes match, show the facility, otherwise hide it and decrement the filtered count
                if (isFeatureMatch && isSizeMatch) {
                    $(this).parent().fadeIn(500, function () {
                        $(this).addClass('d-flex');
                    });
                } else {
                    $(this).parent().fadeOut(500, function () {
                        $(this).removeClass('d-flex');
                    });
                    filteredCount--;
                }
            });
            // Update the text of the element with id 'filtered-count' to show the number of facilities that weren't filtered out
            $('#filtered-count').text(filteredCount);

            // If the checkbox change event was not triggered by loadFromURL, update the URL to reflect the selected features and sizes
            if (!triggeredByLoadFromURL) {
                updateURL(selectedFeatureValues, selectedSizeValues);
            }
        });
        loadFromURL();
    });
}
// Function to update the data attributes
function updateCardIndexes() {
    var visibleIndex = 1; // Start indexing from 1

    $(".market-table .market-card").each(function () {
    if (!$(this).hasClass("filtered")) {
        $(this).find(".card-market-loc-pin").attr("data-index", visibleIndex);
        $(this).find(".fa-map-marker").attr("data-content", visibleIndex);
        visibleIndex++; // Increment only for visible cards
    }
    });
}

// Run the function when the .feature-checkbox changes
$(".feature-checkbox").on("change", function () {
    updateCardIndexes();
});